const checkPermission = (code) => {
    let permissionList = JSON.parse(localStorage.getItem('skinPermission'));
    //console.log(permissionList)
    if (!permissionList) {
        return false;
    }
    for (let i = 0; i < permissionList.length; i++) {
        if (permissionList[i] === code) {
            return true;
        }
        if (i === permissionList.length - 1) {
            return false;
        }
    }
}
export { checkPermission }